<template>
	<ui-icon
		name="logo-wheat-only"
		class="animate-spin filter grayscale"
		:class="[`w-${size} h-${size}`]"
		alt="Loading"
	/>
</template>
<script>
import Vue from "vue";

export default {
	props: {
		size: {
			required: false,
			type: Number,
			default: 24,
		},
	},
};
</script>

<style scoped></style>
